import { Component, OnInit, ViewChild, Input } from "@angular/core";
import { MatMenu } from "@angular/material";
import { MainMenu } from '../../Models/Userinfo';

@Component({
  selector: "app-menu-panel",
  templateUrl: "./menu-panel.component.html"
})
export class MenuPanelComponent implements OnInit {
  @ViewChild("menu", { static: true }) menu: MatMenu;
  @Input() items: MainMenu[];

  constructor() { }

  ngOnInit() { }
}
